var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 35H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8469 35.1807H26.2476L25.9549 34.9246L19.2658 19.5907L19.0081 19L18.7253 19.5781L11.2227 34.912L11 35.3671H11.49H14.4911H14.6765L14.7595 35.1941L18.9809 26.3902L22.8469 35.1807Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37.6667V38H35.7374H23.2416H23.068L23 37.7971V35H24.8817H35.7374H36V35.3333V37.6667Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1246 41H12.3205L12.4 40.8219L14.8116 35.4219L15 35H14.5361H11.5217H11.3276L11.2472 35.1759L9.82032 38.3H7.30145H7V38.6V40.7V41H7.30145H12.1246Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 34.9246H33.2912L39.9803 19.5907L40.238 19L40.5208 19.5781L48.0234 34.912L48.2461 35.3671H47.7561H44.755H44.5696L44.4866 35.1941L40.2652 26.3902L36.5 34.9246Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1215 41H46.9256L46.8461 40.8219L44.4345 35.4219L44.2461 35H44.71H47.7244H47.9185L47.9988 35.1759L49.4258 38.3H51.9446H52.2461V38.6V40.7V41H51.9446H47.1215Z",
    fill: "#E94C69",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatman);
export default __webpack_public_path__ + "static/media/batman.116c083ae19ba15b06ad89f34def292c.svg";
export { ForwardRef as ReactComponent };